import { Container } from '@mui/material';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import Page from '../../../components/Page';
import { useParams } from 'react-router-dom';
import ShapeForm from './ShapeForm';

const index = () => {
  const params: any = useParams();
  const isAddMode = !params?.id;
  return (
    <Page title={'Shape'}>
      <Container maxWidth={'xl'}>
        <HeaderBreadcrumbs
          heading={`${isAddMode ? 'Add Shape' : 'Edit Shape'} `}
          links={[
            { name: 'Dashboard', href: '/' },
            { name: 'Shape', href: '/shape' },
          ]}
        />
        <ShapeForm />
      </Container>
    </Page>
  );
};

export default index;
